type PriceInput = {
    amount?: number | null;
    compareTo?: number | null;
    code?: unknown;
    discount?: unknown;
};

export function getPricePresentation({ amount, compareTo, code, discount }: PriceInput) {
    const reason = Number(code);
    const oldPrice = reason !== 96 && typeof compareTo === "number" && compareTo !== amount
        ? compareTo : null;
    const percentage = reason === 96 || reason === 6 ? null
        : typeof discount === "number" ? discount
        : typeof amount === "number" && oldPrice !== null && oldPrice > amount && oldPrice > 0
          ? Math.round((oldPrice - amount) / oldPrice * 100) : null;

    return {
        oldPrice,
        discount: percentage !== null && percentage > 0 ? percentage : null,
        isRed: reason === 6 || reason === 97 || (reason !== 96 && oldPrice !== null),
    };
}

export function getCalculatedPricePresentation(price?: {
    calculated_amount?: number | null;
    original_amount?: number | null;
    code?: unknown;
    discount?: unknown;
    raw_calculated_amount?: unknown;
} | null) {
    const raw = price?.raw_calculated_amount as { code?: unknown; discount?: unknown } | null;
    return getPricePresentation({
        amount: price?.calculated_amount,
        compareTo: price?.original_amount,
        code: price?.code ?? raw?.code,
        discount: price?.discount ?? raw?.discount,
    });
}
